import { useMediaQueries } from "@/shared";

import CreditBehaviourDesktopTable from "./Desktop/CreditBehaviourDesktopTable";
import CreditBehaviourMobileTable from "./Mobile/CreditBehaviourMobileTable";
import useCreditBehaviourData from "./useCreditBehaviourData";

const CreditBehaviourTable = () => {
  const { toMd } = useMediaQueries();

  const { columns, dataRows } = useCreditBehaviourData();

  return (
    <div>
      {toMd ? (
        <CreditBehaviourMobileTable columns={columns} dataRows={dataRows} />
      ) : (
        <CreditBehaviourDesktopTable columns={columns} dataRows={dataRows} />
      )}
    </div>
  );
};

export default CreditBehaviourTable;
